import type { SubjectAssignment, ExamInfo, ExamStudent } from './types';

// ─── Subject/class assignments for the current teacher ───────────────────────
export const MOCK_ASSIGNMENTS: SubjectAssignment[] = [
  {
    assignmentId: 'a1',
    classId: 5, className: 'Class 5', sectionId: 51, sectionName: 'A',
    subjectId: 101, subjectName: 'Mathematics', studentCount: 32,
  },
  {
    assignmentId: 'a2',
    classId: 5, className: 'Class 5', sectionId: 52, sectionName: 'B',
    subjectId: 101, subjectName: 'Mathematics', studentCount: 30,
  },
  {
    assignmentId: 'a3',
    classId: 6, className: 'Class 6', sectionId: 61, sectionName: 'A',
    subjectId: 102, subjectName: 'Science', studentCount: 34,
  },
  {
    assignmentId: 'a4',
    classId: 7, className: 'Class 7', sectionId: 71, sectionName: 'A',
    subjectId: 101, subjectName: 'Mathematics', studentCount: 28,
  },
];

// ─── Ongoing exams for each (classId + sectionId) ────────────────────────────
export const MOCK_EXAMS: ExamInfo[] = [
  {
    id: 201, name: 'Unit Test 1', category: 'unit_test',
    examDate: '2026-07-10', startDate: '2026-07-08', endDate: '2026-07-15',
    status: 'ongoing',
    classId: 5, sectionId: 51,
    subjects: [
      { subjectId: 101, subjectName: 'Mathematics', maxMarks: 25, minMarks: 8 },
    ],
  },
  {
    id: 202, name: 'Mid Term', category: 'mid_term',
    examDate: '2026-07-12', startDate: '2026-07-10', endDate: '2026-07-20',
    status: 'ongoing',
    classId: 5, sectionId: 51,
    subjects: [
      { subjectId: 101, subjectName: 'Mathematics', maxMarks: 80, minMarks: 26 },
    ],
  },
  {
    id: 203, name: 'Unit Test 1', category: 'unit_test',
    examDate: '2026-07-11', startDate: '2026-07-10', endDate: '2026-07-16',
    status: 'ongoing',
    classId: 5, sectionId: 52,
    subjects: [
      { subjectId: 101, subjectName: 'Mathematics', maxMarks: 25, minMarks: 8 },
    ],
  },
  {
    id: 204, name: 'Weekly Quiz', category: 'other',
    examDate: '2026-07-13', startDate: '2026-07-13', endDate: '2026-07-13',
    status: 'ongoing',
    classId: 6, sectionId: 61,
    subjects: [
      { subjectId: 102, subjectName: 'Science', maxMarks: 20, minMarks: 7 },
    ],
  },
  {
    id: 205, name: 'Final Exam', category: 'final',
    examDate: '2026-09-05', startDate: '2026-09-01', endDate: '2026-09-15',
    status: 'upcoming',
    classId: 5, sectionId: 51,
    subjects: [
      { subjectId: 101, subjectName: 'Mathematics', maxMarks: 100, minMarks: 33 },
    ],
  },
  {
    id: 206, name: 'Unit Test 2', category: 'unit_test',
    examDate: '2026-07-14', startDate: '2026-07-14', endDate: '2026-07-20',
    status: 'ongoing',
    classId: 7, sectionId: 71,
    subjects: [
      { subjectId: 101, subjectName: 'Mathematics', maxMarks: 30, minMarks: 10 },
    ],
  },
];

// ─── Roster of students per class+section ───────────────────────────────────
const FIRST_NAMES = [
  'Aarav', 'Vivaan', 'Aditya', 'Vihaan', 'Arjun', 'Sai', 'Reyansh', 'Ayaan',
  'Krishna', 'Ishaan', 'Ananya', 'Aadhya', 'Diya', 'Saanvi', 'Myra',
  'Riya', 'Anika', 'Kiara', 'Aarohi', 'Prisha',
];
const LAST_NAMES = [
  'Sharma', 'Verma', 'Iyer', 'Patel', 'Kumar', 'Singh', 'Nair', 'Rao',
  'Joshi', 'Reddy', 'Gupta', 'Malhotra',
];

function pick<T>(arr: T[], i: number): T {
  return arr[i % arr.length];
}

export function buildRoster(
  classId: number,
  sectionId: number,
  count: number,
): ExamStudent[] {
  const students: ExamStudent[] = [];
  for (let i = 1; i <= count; i++) {
    const first = pick(FIRST_NAMES, (classId * 3 + sectionId + i) as number);
    const last  = pick(LAST_NAMES,  (sectionId * 5 + i) as number);
    students.push({
      id: classId * 1000 + sectionId * 100 + i,
      name: `${first} ${last}`,
      rollNo: String(i).padStart(2, '0'),
      uid: `VAV${classId}${sectionId}${String(i).padStart(3, '0')}`,
      marks: {},
    });
  }
  return students;
}
